import React from 'react'
import { useSelector } from 'react-redux'

const featuredTitle = {
  en: 'Featured Programs',
  id: 'Program Unggulan'
}

/*
  Jumlah featured programs per organization card: 5 items.
  Contoh struktur data:

  const programs = [
    {
      title: {
        en: 'Eiusmod duis magna cupida...',
        id: 'Eiusmod duis magna cupida...'
      },
      thumbnail: '/images/posters/khub_poster1.jpg'
    },
  ]
*/

const FeaturedProgram = ({title, image}) => {
  return (
    <>
      <div
        style={{backgroundImage: `url('${image}')`, height: '62px'}}
        className="mb-1 rounded bg-no-repeat bg-center bg-cover shadow"
      />
      <div className="text-sm leading-tight text-gray-444 break-words">
        {title}
      </div>
    </>
  )
}

const CardFeaturedPrograms = ({programs = []}) => {
  const language = useSelector(state => state.system.language)
  const sliced = programs.length > 5 ? programs.slice(0, 5) : programs

  return sliced && sliced.length > 0 ? (
    <>
      <hr className="my-5"/>
      <p className="text-xs text-gray-999 mb-2">
        {featuredTitle[language.name]}
      </p>
      <div className="flex pr-4 -mx-2">
        {
          sliced.map((p, index) => (
            <div
              className="w-1/5 px-2"
              key={index}
            >
              <FeaturedProgram
                title={p.title[language.name]}
                image={p.thumbnail}
              />
            </div>
          ))
        }
      </div>
    </>
  ) : <></>
}

export default CardFeaturedPrograms
